<template>
	<div>
		<!-- 产品管理 -->
		<div class="cardlist">
			<div class="card">
				<div class="p1">剪发</div>
				<div class="p2">月销总量</div>
				<!-- <div class="p3">{{this.nums.hairCutNum}}</div> -->
				<div class="p3">30000</div>
			</div>
			<div class="card">
				<div class="p1">儿童剪</div>
				<div class="p2">月销总量</div>
				<!-- <div class="p3">{{this.nums.childNum}}</div> -->
				<div class="p3">30000</div>
			</div>
			<div class="card">
				<div class="p1">刘海剪发</div>
				<div class="p2">月销总量</div>
				<!-- <div class="p3">{{this.nums.fontNum}}</div> -->
				<div class="p3">30000</div>
			</div>
		</div>
		<!--  -->
		<el-button type="primary" style="margin-top: 25px;" @click="goaddhair" size="small">新建服务</el-button>
		<el-table :cell-style="{'text-align':'center'}"
			:header-cell-style="{background:'#F2F2F4','text-align':'center'}" ref="multipleTable" :data="tableData"
			tooltip-effect="dark" style="width: 100%;margin-top: 15px;">
			<el-table-column prop="id" label="产品服务ID" width="100px"> </el-table-column>
			<el-table-column prop="title" label="产品服务名称"> </el-table-column>
			<el-table-column prop="type" label="服务类型">
				<template slot-scope="scope">
					{{scope.row.type | typeFormat}}
				</template>
			</el-table-column>
			<el-table-column prop="msg" label="服务描述"> </el-table-column>
      <el-table-column prop="letter" label="排队标识"> </el-table-column>
<!--			<el-table-column prop="serviceManTime" label="男士服务时长(分)" width="130px"> </el-table-column>-->
<!--			<el-table-column prop="serviceWomanTime" label="女士服务时长(分)" width="130px"> </el-table-column>-->
<!--			 <el-table-column  prop="letter" label="提成"> </el-table-column> -->
<!--			<el-table-column label="业绩">-->
<!--				<template slot-scope="scope">-->
<!--					{{scope.row.commission?scope.row.commission:'暂未填写'}}-->
<!--				</template>-->
<!--			</el-table-column>-->
			<el-table-column prop="updateTime" label="创建日期"> </el-table-column>
			<el-table-column prop="nowIntroduction" label="立即推出/显示在用户端">
				<template slot-scope="scope">
					<span v-if="scope.row.nowIntroduction==0" >是</span>
					<span v-if="scope.row.nowIntroduction==1" style="color: red;">否</span>
				</template>
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="{row}">
					<el-button type="text" @click="delit(row.id)">编辑</el-button>
					<el-button type="text" @click="updown(row.id, row.state==0?1:0)">
						<span v-if="row.state==0" style="color:#e36;">上架</span>
						<span v-else style="color:limegreen;">下架</span>
					</el-button>
					<div>{{row.remove==0?'':'已删除'}}</div>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				pages: {
					total: "",
					pageNum: 1,
					pageSize: 100
				},
				tableData: [],
				nums: {
					hairCutNum: 0,
					childNum: 0,
					fontNum: 0,
				}
			}
		},
		mounted() {
			this.getlist()
			this.getNum()
		},
		filters: {
			typeFormat(val) {
				switch (val) {
          case -1:
            return "团购优惠";
					case 0:
						return "剪发服务";
					case 1:
						return "染发服务";
					case 2:
						return "洗吹服务";
          case 3:
            return "护理服务";
          case 4:
            return "造型";
          case 5:
            return "迷你烫";
          case 6:
            return "健康染发";
          case 7:
            return "健康烫发";
          case 8:
            return "洗吹护理";
          case 9:
            return "美甲";
          case 10:
            return "接发";
          case 11:
            return "特惠项目";
					default:
						return "/";
				}
			}
		},
		methods: {
			//编辑
			delit(id) {
				this.$router.push({
					path: 'add_hair',
					query: {
						id: id
					}
				})
			},
			// 上架下架
			updown(id, state) {
				let data = {
					id: id,
					state: state,
				}
				this.$http.post("dhaircut/shelfService", JSON.stringify(data)).then(res => {
					if (res.body.code != 200) {
						this.$message.error(res.body.msg);
					} else {
						this.getlist()
						this.$message.success("上架/下架成功！");
					}
				})
			},
			goaddhair() {
				this.$router.push({
					path: "/add_hair"
				})
			},
			// 获取剪发列表
			getlist() {
				this.$http.post("dhaircut/findDhaircutService", JSON.stringify(this.pages)).then(function(res) {
					if (res.body.code == 200) {
						this.tableData = res.body.data.records
						// this.tableData=res.body.data
						this.pages.total = res.body.data.total
					} else {
						this.$message.error(res.body.msg)
					}
				}, function(err) {
					this.$message.error("请求失败")
				})
			},
			//统计销量
			getNum() {
				this.$http.get("dhaircut/count").then(res => {
					this.nums.hairCutNum = res.body.data.hairCutNum;
					this.nums.childNum = res.body.data.childNum;
					this.nums.fontNum = res.body.data.fontNum;
				})
			}
		}
	}
</script>
<style lang="less" scoped>
	.cardlist {
		display: flex;

		.card {
			padding: 15px;
			box-sizing: border-box;
			background-color: #F2F2F2;
			border-radius: 5px;
			margin-left: 20px;
			flex: 1;

			&:nth-child(1) {
				margin-left: 0px;
			}

			.p1 {
				font-size: 20px;
				font-weight: bold;
			}

			.p2 {
				font-size: 18px;
				margin-top: 10px;
			}

			.p3 {
				font-size: 40px;
				text-align: center;
				margin-top: 20px;
				margin-bottom: 20px;
			}
		}
	}
</style>